import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { Flex } from "@rebass/grid/emotion"

export const BenefitsWrapper = styled(Flex)`
  border: 1px ${theme.wild.color.nova.transparency.black[20]} solid;
  border-radius: 4px;
  flex-direction: column;

  &.duo-pdp-benefits {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  &.perfectPairLp-override {
    @media (max-width: 767px) {
      border-left: 0;
      border-right: 0;
      border-radius: 0;
    }
    @media (min-width: ${theme.mediaqueries.small}) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .benefit {
      gap: 8px;
    }

    .benefit-heading-two {
      padding-top: 8px;
      @media (min-width: ${theme.mediaqueries.medium}) {
        padding-top: 16px;
      }
    }
  }
`

export const Benefit = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  @media (min-width: 768px) {
    padding: 24px;
  }

  &:not(:first-of-type) {
    border-top: 1px ${theme.wild.color.nova.transparency.black[20]} solid;
  }
`

export const BenefitsItem = styled(Flex)`
  gap: 8px;

  align-items: baseline;
  @media (min-width: 1024px) {
    gap: 16px;
  }

  svg {
    //transform: translateY(-1px);
  }

  p {
    line-height: 20px !important;
    @media (min-width: 1024px) {
      line-height: 22px !important;
    }
  }
`
